"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionContextMenu = void 0;
const react_1 = __importStar(require("react"));
const classFunctions_1 = require("../../../../../utils/classFunctions");
const actionButton_1 = require("../actionButton");
require("./index.scss");
const className = 'action-context-menu';
const noneClick = () => { };
const ActionContextMenu = (props) => {
    const { openOnHover, showUp, actions, modificators } = props;
    const [isOpened, setIsOpened] = (0, react_1.useState)();
    const toggleOpen = () => {
        if (openOnHover) {
            return;
        }
        setIsOpened(!isOpened);
    };
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        modificators,
        openOnHover ? 'open-on-hover' : undefined,
        showUp ? 'up' : undefined,
    ]);
    const getList = () => {
        if (!isOpened && !openOnHover)
            return null;
        return (react_1.default.createElement("div", { className: `${className}__dropdown` },
            react_1.default.createElement("ul", { className: `${className}__dropdown-list` }, actions.map((action, key) => (react_1.default.createElement("li", { key: key, className: `${className}__item` }, action))))));
    };
    if (actions.length === 0)
        return null;
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { onClick: toggleOpen, className: `${className}__button`, role: 'button' }, (0, actionButton_1.renderActionButton)({
            key: 'context',
            click: noneClick,
            kind: 'icon',
            iconName: 'dots-circle',
            text: '',
        })),
        getList()));
};
exports.ActionContextMenu = ActionContextMenu;
//# sourceMappingURL=index.js.map